<div class="modal fade" id="addNewAcademicTerm" tabindex="-1" aria-labelledby="addNewAcademicTermLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="border-0 shadow modal-content rounded-4">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <div class="py-5 modal-header px-7">
          <h4 class="modal-title fw-bold text-dark">
            ช่วงเวลาการศึกษา
          </h4>

          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearForm()"></button>
        </div>

        <div class="px-10 py-8 modal-body">
          <div class="row g-6">
            <div class="col-md-6">
              <app-select formControlName="term" label="เทอมการศึกษา" [options]="['1', '2', '3']" [required]="true"
                [searchable]="false" [errorMessage]="erros.term" [disabled]="this.academicTermId !==null"
                [error]="erros.term"></app-select>
            </div>

            <div class="col-md-6">
              <app-select formControlName="year" label="ปีการศึกษา" [options]="yearOptions"
                [required]="true" [searchable]="false" [errorMessage]="erros.year"
                [error]="erros.year"></app-select>
            </div>

            <div class="col-12">
      
              <app-daterange-picker formControlName="studyPeriod" label="ระยะเวลาภาคการศึกษา" name="termRange"
                [required]="true" classes="mb-2" [errorMessage]="erros.studyPeriod"
                [error]="erros.studyPeriod"></app-daterange-picker>

            </div>

            <div class="col-12">
              <app-daterange-picker formControlName="midtermPeriod" label="ช่วงสอบกลางภาค" name="midTerm"
                [required]="true" classes="mb-2"[errorMessage]="erros.midtermPeriod"[error]="erros.midtermPeriod"></app-daterange-picker>
            </div>

            <div class="col-12">
              <app-daterange-picker formControlName="finalPeriod" label="ช่วงสอบปลายภาค" name="finalTerm"
                [required]="true" classes="mb-2" [errorMessage]="erros.finalPeriod" [error]="erros.finalPeriod"></app-daterange-picker>
            </div>
          </div>

          @if (academicTermId !== null) {
            <div class="academic-term-reg-sync-section">
              <h5 class="academic-term-reg-sync-title">การนำเข้าข้อมูลจาก REG</h5>
              <button
                type="button"
                class="btn academic-term-reg-sync-button"
                [disabled]="!canSyncWorkload()"
                (click)="onSyncWorkload()"
              >
                @if (isSyncing) {
                  กำลังนำเข้า...
                } @else if (isAcademicTermSynced()) {
                  นำเข้าแล้ว
                } @else {
                  นำเข้าข้อมูลจากระบบ REG
                }
              </button>
              @if (isAcademicTermSynced()) {
                <span class="academic-term-reg-sync-at">
                  {{ getAcademicTermSyncAtLabel() }}
                </span>
              }
            </div>
          }
        </div>


        <div class="px-10 pt-2 pb-8 border-0 modal-footer academic-term-modal-footer">
          <div class="academic-term-modal-actions">
            <button type="button" class="btn btn-secondary btn-lg fw-bold" data-bs-dismiss="modal"
              (click)="clearForm()">
              {{ "COMPONENT.CANCEL" | translate }}
            </button>

            <button type="submit" class="text-white btn btn-lg fw-bold"
              style="background-color: #5E0B0D; border-color: #5E0B0D;" [disabled]="isSaving || isSyncing">
              {{ "COMPONENT.SAVE" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<app-confirm-dialog
  #saveAcademicTermConfirmDialog
  modalId="saveAcademicTermConfirm"
  icon="warning"
  title="ยืนยันการบันทึกข้อมูล"
  message="คุณต้องการบันทึกข้อมูลนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isSaving"
  (confirmed)="onConfirmSave()"
></app-confirm-dialog>
<app-confirm-dialog
  #syncWorkloadConfirmDialog
  modalId="syncWorkloadConfirm"
  icon="warning"
  title="ยืนยันการนำเข้าข้อมูลจาก REG"
  message="คุณต้องการนำเข้าข้อมูลรายวิชาจาก REG สำหรับเทอมนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isSyncing"
  [stackAboveModal]="true"
  (confirmed)="onConfirmSyncWorkload()"
></app-confirm-dialog>

<app-loading-dialog
  #syncWorkloadLoadingDialog
  modalId="syncWorkloadLoading"
  title="กำลังนำเข้าข้อมูลจาก REG"
  message="ระบบกำลังประมวลผลข้อมูลรายวิชาและตารางสอน กรุณารอสักครู่"
  [stackAboveModal]="true"
></app-loading-dialog>

<div
  class="modal fade academic-term-sync-error-modal"
  id="syncWorkloadError"
  tabindex="-1"
  aria-labelledby="syncWorkloadErrorLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered academic-term-sync-error-dialog">
    <div class="border-0 shadow modal-content rounded-4">
      <div class="py-5 modal-header px-7">
        <h4 id="syncWorkloadErrorLabel" class="modal-title fw-bold text-dark">
          ไม่สามารถ Sync ข้อมูลได้
        </h4>

        <button type="button" class="btn-close" aria-label="Close" (click)="closeSyncWorkloadErrorModal()"></button>
      </div>

      <div class="py-6 px-7 modal-body">
        <div class="mb-5 academic-term-sync-error-alert">
          <span class="academic-term-sync-error-alert-icon" aria-hidden="true">!</span>
          {{ syncErrorMessage }}
        </div>

        @if (syncErrorRows.length > 0) {
          <div class="table-responsive academic-term-sync-error-table-scroll">
            <table class="table mb-0 academic-term-sync-error-table">
              <thead>
                <tr>
                  <th>ลำดับ</th>
                  <th>ส่วนที่นำเข้า</th>
                  <th>รหัสวิชา</th>
                  <th>Section</th>
                  <th>อีเมลอาจารย์</th>
                  <th>รายละเอียด</th>
                </tr>
              </thead>
              <tbody>
                @for (error of syncErrorRows; track error.no) {
                  <tr>
                    <td>{{ error.no }}</td>
                    <td>{{ error.source || '-' }}</td>
                    <td>{{ error.coursecode || '-' }}</td>
                    <td>{{ error.section || '-' }}</td>
                    <td>{{ error.kkumail || '-' }}</td>
                    <td class="academic-term-sync-error-description">{{ error.description || '-' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>

      <div class="pt-2 pb-6 border-0 px-7 modal-footer academic-term-sync-error-footer">
        <button
          type="button"
          class="btn academic-term-sync-download-button"
          [disabled]="syncErrorRows.length === 0"
          (click)="downloadSyncWorkloadErrorFile()"
        >
          <img
            src="assets/media/icons/svg/file-down.svg"
            class="academic-term-sync-button-icon"
            alt=""
            aria-hidden="true"
          />
          <span>ดาวน์โหลดไฟล์ Error</span>
        </button>
        <button type="button" class="btn academic-term-sync-error-close-button" (click)="closeSyncWorkloadErrorModal()">
          ปิด
        </button>
      </div>
    </div>
  </div>
</div>
